import React from "react";
import "./message.css";
import { useTranslation } from "react-i18next";


const Message = (props) => {

  const { t } = useTranslation(["translation"]);
  return (
    <div className="noSearchesWrapper">
      <div className="noSearches">
        <p>{props.message?t("label_Search_Main"):t("label_Search_Alt")} </p>
        <p style={{fontWeight:'500'}}>{t( "label_Suggestion")+" : "}</p>
        <ul>
          <li>{t("label_Suggest_First")}</li>
          <li>{t("label_Suggest_Two")}</li>
          <li>{t("label_Suggest_Three")}</li>
          <li>{t("label_Suggest_Four")}</li>
        </ul>
      </div>
    </div>
  );
};

export default Message;
